/**
 * Quiz override types — Track 5.Y-cat-quiz-admin Commit 1.
 *
 * Client-safe shape declarations + accessor helpers. No DB imports;
 * safe to import from client components.
 *
 * The server-only loader (loadQuizOverrides + serializeQuizOverrides)
 * lives next door in ./load-overrides.ts and pulls in `@/lib/db`. Keep
 * these types in their own file so client components can consume the
 * accessor helpers without webpack pulling postgres into the bundle.
 */

export type QuizKey = 'start' | 'clarity';
// help_text dropped from CHECK in migration 0064 (Track
// 5.Y-cat-quiz-composer-tightening). The schema column accepts only
// {title, subtitle} now; re-widen if a renderer surface for help_text
// ships.
export type QuizStepFieldName = 'title' | 'subtitle';

/** Plain-object form for crossing the server→client boundary (Map
 *  doesn't transit through Next.js prop transport). */
export interface SerializedQuizOverrides {
  steps: Record<string, Partial<Record<QuizStepFieldName, string>>>;
  options: Record<string, string>;
}

export const EMPTY_SERIALIZED_QUIZ_OVERRIDES: SerializedQuizOverrides = {
  steps: {},
  options: {},
};

/** Per-step accessor — uses plain-object form. Pass through hardcoded
 *  fallback when no override is stored. */
export function applyStepOverrideSerialized(
  o: SerializedQuizOverrides | null,
  stepId: string,
  fieldName: QuizStepFieldName,
  hardcoded: string,
): string {
  return o?.steps[stepId]?.[fieldName] ?? hardcoded;
}

/** Per-option label accessor — same shape, keyed by `${stepId}:${optionValue}`. */
export function applyOptionOverrideSerialized(
  o: SerializedQuizOverrides | null,
  stepId: string,
  optionValue: string,
  hardcoded: string,
): string {
  return o?.options[`${stepId}:${optionValue}`] ?? hardcoded;
}
